// TODO check if this is needed
require('normalize.css');

// Handles default styling for headers/html/body etc
require('styles/App.styl');

// TODO afaik only used by toast, I would prefer to replace this with something
// which has easier to track usages.
require('animate.css');
